import { useQuery, useQueryClient, UseQueryOptions } from "@tanstack/react-query";
import { useCallback } from "react";
import { getConfig } from "../config";
import { totpSecretStore } from "../idb/TOTPSecretStore";
import { fetchLocker } from "../services/lockerApi";
import { queryKeys } from "../queryKeys";

export default function useGetLocker(
  options?: UseQueryOptions<
    unknown,
    unknown,
    Locker,
    ReturnType<typeof queryKeys.locker.detail>
  > & {
    skipIndexedDB?: boolean;
  }
) {
  const { lockerId } = getConfig();
  const queryClient = useQueryClient();
  const { skipIndexedDB, ...queryOptions } = options ?? {};

  const addToIndexedDB = useCallback(
    async (data: TOTPSecret[]) => {
      try {
        await totpSecretStore.clear();
        await totpSecretStore.putAll(data);
        queryClient.invalidateQueries({ queryKey: queryKeys.totpSecrets });
      } catch (error) {
        console.error("Failed to add TOTP secrets to IndexedDB:", error);
      }
    },
    [queryClient]
  );

  return useQuery({
    queryFn: () => fetchLocker(),
    queryKey: queryKeys.locker.detail(lockerId),
    placeholderData: {
      config: {
        language: "fr",
        support_phone: "1-833-622-0304",
        support_email: "info@expedibox.com",
        support_website: "support.expedibox.com",
      },
    },
    ...queryOptions,
    onSuccess: async (data: Locker) => {
      if (
        !skipIndexedDB &&
        Array.isArray(data?.totp_secrets) &&
        data.totp_secrets.length > 0
      ) {
        await addToIndexedDB(data.totp_secrets);
      }
      queryOptions.onSuccess?.(data);
    },
  });
}

export const getLocker = fetchLocker;
